import React from 'react';
import { TableRow, TableCell, Toggle } from '@weezevent/nacre';
import { RateStatus } from '../../../rates/components/rateStatus';

import Style from '../editCrossSelling.module.css';

export default function PutForSaleRateRow({ productId, rate, quotas, event, rateGroup, category, forSaleArray, setForSaleArray }) {
    const className = rateGroup ? (rateGroup.parent ? Style['subgroup-mev'] : Style['groupe-mev']) : '';

    const correspondingRate = React.useMemo(() => {
        return forSaleArray.find(s => s.rate === rate.id);
    }, [forSaleArray, rate]);

    const noProductsInSale = React.useMemo(() => {
        return !forSaleArray.find(s => s.rate === rate.id)?.is_product_in_sale;
    }, [forSaleArray, rate]);

    const rateActionToggle = React.useCallback(
        action => {
            if (correspondingRate) {
                correspondingRate[action] = !correspondingRate[action];
            } else {
                forSaleArray.push({
                    event: event.id,
                    category,
                    is_mandatory_product: action === 'is_mandatory_product' ? false : true,
                    is_opened_product: action === 'is_opened_product' ? false : true,
                    is_product_in_sale: false,
                    product: productId,
                    rate: rate.id
                });
            }
            setForSaleArray([...forSaleArray]);
        },
        [event, category, rate, productId, forSaleArray, correspondingRate]
    );

    const onToggleIcon = React.useCallback(() => {
        if (correspondingRate) {
            correspondingRate.is_product_in_sale = !correspondingRate.is_product_in_sale;
        } else {
            forSaleArray.push({
                event: event.id,
                category,
                is_mandatory_product: false,
                is_opened_product: false,
                is_product_in_sale: noProductsInSale,
                product: productId,
                rate: rate.id
            });
        }
        if (forSaleArray.some(s => s.rate && !s.is_product_in_sale)) {
            const eventMEV = forSaleArray.filter(r => r.event === event.id).find(r => !r.rate);
            if (eventMEV) eventMEV.is_product_in_sale = false;
        }
        setForSaleArray([...forSaleArray]);
    }, [forSaleArray, event, rate, category, productId, noProductsInSale, correspondingRate]);

    return (
        <TableRow key={`rate-${rate.id}`}>
            <TableCell className={className}>{rate.resolved_name}</TableCell>
            <TableCell>
                <Toggle onChange={() => rateActionToggle('is_mandatory_product')} checked={correspondingRate?.is_mandatory_product} />
            </TableCell>
            <TableCell>
                <Toggle onChange={() => rateActionToggle('is_opened_product')} checked={correspondingRate?.is_opened_product} />
            </TableCell>
            <TableCell>
                <Toggle onChange={onToggleIcon} checked={!noProductsInSale} />
            </TableCell>
            <TableCell>{<RateStatus quotas={quotas} rate={rate} settings={event.settings} event={event} />}</TableCell>
        </TableRow>
    );
}
